import React from 'react';
import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton } from '@fluentui/react';
import { t } from 'i18next';

interface DialogConfirmGenerateReportProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const DialogConfirmGenerateReport: React.FC<DialogConfirmGenerateReportProps> = ({ isOpen, onConfirm, onCancel }) => {
  return (
    <Dialog
      hidden={!isOpen}
      dialogContentProps={{
        type: DialogType.normal,
        title: t('Confirmar generación del reporte'),
      }}
      modalProps={{
        isBlocking: true,
      }}
      maxWidth={450}
      onDismiss={onCancel}
    >
      <div>
        {t(
          'Se iniciará el proceso de generación de la liquidación de horas. Dependiendo de la cantidad de información, este proceso puede tardar algunos minutos.',
        )}
      </div>

      <DialogFooter>
        <PrimaryButton onClick={onConfirm} text={t('Generar reporte')} />
        <DefaultButton onClick={onCancel} text={t('Cancelar')} />
      </DialogFooter>
    </Dialog>
  );
};

export default DialogConfirmGenerateReport;
